﻿import { Direcciones } from './direcciones';
import { ParametroUsuario } from './parametro-usuario';

export class UserPeticiones {
    id: number;
    Id: number;
    FECHA_ALTA_PETICION: Date;
    ID_SOLICITANTE: number;
    ID_USU_ACEPTA: number;
    NOMBRE_USU_ACEPTA: string;
    APELLIDOS_USU_ACEPTA: string;

    ID_GRUPO: number;
    NOMBRE: string;
    USUARIO: string;
    APELLIDOS: string;
    GRUPO_NUEVO: string;
    CLIENTE: string;
    EMAIL: string;
    FECHA_FIN_PROCESO: Date;
    SUPERVISOR: number;
    USER_SOLICITANTE: string;
    NOMBRE_SOLICITANTE: string;
    APELLIDOS_SOLICITANTE: string;
    EMAIL_SOLICITANTE: string;
    ID_CLIENTE: number;
    TELEFONO: number;
    EXTRAER_SERIES: number;
    
    constructor() { }


    static toModel(json: string): UserPeticiones {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new UserPeticiones();
        toReturn.Id = data.Id;
        toReturn.FECHA_ALTA_PETICION = data.FECHA_ALTA_PETICION;
        toReturn.ID_SOLICITANTE = data.ID_SOLICITANTE;
        toReturn.ID_USU_ACEPTA = data.ID_USU_ACEPTA;

        toReturn.ID_GRUPO = data.ID_GRUPO;
        toReturn.NOMBRE = data.NOMBRE;
        toReturn.USUARIO = data.USUARIO;
        toReturn.APELLIDOS = data.APELLIDOS;
        toReturn.GRUPO_NUEVO = data.NOMBRE_GRUPO;
        toReturn.CLIENTE = data.NOMBRE_CLIENTE;
        toReturn.ID_CLIENTE = data.ID_CLIENTE;
        if (data.UsuarioValidador != null) {
            toReturn.NOMBRE_USU_ACEPTA = data.UsuarioValidador.NOMBRE;
            toReturn.APELLIDOS_USU_ACEPTA = data.UsuarioValidador.APELLIDOS;
        }
        toReturn.CLIENTE = data.NOMBRE_CLIENTE;
        toReturn.ID_CLIENTE = data.ID_CLIENTE;

        toReturn.EMAIL = data.EMAIL;
        toReturn.FECHA_FIN_PROCESO = data.FECHA_FIN_PROCESO;
        toReturn.SUPERVISOR = data.SUPERVISOR;
        toReturn.USER_SOLICITANTE = data.UsuarioSolicitante.USER;
        toReturn.NOMBRE_SOLICITANTE = data.UsuarioSolicitante.NOMBRE;
        toReturn.APELLIDOS_SOLICITANTE = data.UsuarioSolicitante.APELLIDOS;
        toReturn.EMAIL_SOLICITANTE = data.UsuarioSolicitante.EMAIL;

        return toReturn;
    }

}


export class ParametrosUsuario {
    Id: number;
    ID_PARAMETRO_CLIENTE_USUARIO: number;
    VALOR: string;
    NOMBRE_PARAMETRO: string;
    DESCRIPCION_PARAMETRO: string;
}

export class Userprofile {
    Id: number;
    USER: string;
    NOMBRE: string;
    APELLIDOS: string;
    ID_GROUP: number;
    groupName: string;
    EMAIL: string;
    ACTIVO: boolean;
    ID_IDIOMA: number;
    IDIOMA: {
        PREFIJO: string
    };
    PARAMETROS: ParametrosUsuario[];
    DIRECCIONES: Direcciones[];
    NOMBRE_CLIENTE: string;
    SUPERVISOR: boolean;
    RECIBIR_NOTIFICACIONES: string;
    TELEFONO: string;
    TELEFONO_OFICINA: string;
    constructor() { }

    static toModel(json: string): Userprofile {
        const data = JSON.parse(json);
        const toReturn = new Userprofile();

        toReturn.Id = data.Id;
        toReturn.USER = data.USER;
        toReturn.NOMBRE = data.NOMBRE;
        toReturn.APELLIDOS = data.APELLIDOS;
        toReturn.ID_GROUP = data.ID_GROUP;
        toReturn.EMAIL = data.EMAIL;
        toReturn.ACTIVO = data.ACTIVO;
        toReturn.ID_IDIOMA = data.ID_IDIOMA;
        toReturn.IDIOMA = { PREFIJO: data.IDIOMA.PREFIJO };
        toReturn.RECIBIR_NOTIFICACIONES = data.RECIBIR_NOTIFICACIONES ? 'SI' : 'NO';
        if (data.DIRECCIONES) {
            toReturn.DIRECCIONES = data.DIRECCIONES.map((direccion: Direcciones) => Direcciones.toModel(JSON.stringify(direccion)));

            toReturn.DIRECCIONES.sort((a, b) => !a.DEFAULT ? 1 : -1);
        }
        toReturn.DIRECCIONES = data.DIRECCIONES ? data.DIRECCIONES.map((direccion: Direcciones) => Direcciones.toModel(JSON.stringify(direccion))) : null;
        toReturn.PARAMETROS = data.PARAMETROS ?
            data.PARAMETROS.map((parametro: ParametroUsuario) => ParametroUsuario.toModel(JSON.stringify(parametro))) : null;
        toReturn.TELEFONO = data.TELEFONO;
        toReturn.TELEFONO_OFICINA = data.TELEFONO_OFICINA;
        toReturn.groupName = data.GROUP.DESCRIPCION;

        return toReturn;
    }
}

export class ParametrosUpdate {
    ID_USUARIO: number;
    ID_USU_PARAM_CLI: number;
    VALOR: string;
    constructor() { }

    static toModel(json: string): Userprofile {
        const data = JSON.parse(json);
        const toReturn = new Userprofile();

        toReturn.Id = data.Id;
        toReturn.USER = data.USER;
        toReturn.NOMBRE = data.NOMBRE;
        toReturn.APELLIDOS = data.APELLIDOS;
        toReturn.ID_GROUP = data.ID_GROUP;
        toReturn.EMAIL = data.EMAIL;
        toReturn.ACTIVO = data.ACTIVO;
        toReturn.ID_IDIOMA = data.ID_IDIOMA;
        toReturn.IDIOMA = { PREFIJO: data.IDIOMA.PREFIJO };
        toReturn.DIRECCIONES = data.DIRECCIONES ? data.DIRECCIONES.map((direccion: Direcciones) => Direcciones.toModel(JSON.stringify(direccion))) : null;
        toReturn.PARAMETROS = data.PARAMETROS ?
            data.PARAMETROS.map((parametro: ParametroUsuario) => ParametroUsuario.toModel(JSON.stringify(parametro))) : null;

        return toReturn;
    }
}

export class UsuarioUpdate {
    Id: number;
    USER: string;
    CURRENT_PASS: string;
    PASS: string;
    NOMBRE: string;
    APELLIDOS: string;
    TELEFONO: string;
    TELEFONO_OFICINA: string;
    ID_GROUP: number;
    ACTIVO: boolean;
    EMAIL: string;
    ID_IDIOMA: number;
    RECIBIR_NOTIFICACIONES: boolean;
    PARAMETROS: ParametroUsuario[];
    constructor() { }
}



export class UsuarioSearch {
    NOMBREAPES: string;
    USERNAME: string;
    ID_USER: number;
    ID_CLIENTE: number;
    ID_GRUPO: number;
    EMAIL: string;
    ACTIVO: boolean;

    constructor() {
        this.NOMBREAPES = undefined;
        this.USERNAME = undefined;
        this.ID_USER = undefined;
        this.ID_CLIENTE = undefined;
        this.ID_GRUPO = undefined;
        this.EMAIL = undefined;
        this.ACTIVO = undefined;
    }
}

export class NuevaPeticion {
    NOMBRE: string;
    APELLIDOS: string;
    ID_GROUP: number;
    SUPERVISOR: boolean;
    EMAIL: string;
    ACTIVO: boolean;
    TELEFONO: string;

    constructor() {
        this.ACTIVO = true;
        this.ID_GROUP = -1;
        this.SUPERVISOR = false;
    }
}

export class ParametrosCliente {
    Id: number;
    ID_CLIENTE: number;
    ID_USU_PARAM: number;
    ParametroUsuario: {
        Id: number;
        NOMBRE: string;
        DESCRIPCION: string;
        VALIDACION_PARAM: string;
        ID_TIPO_DATO: number;
        Tipodato: {
            Id: number;
            NOMBRE: string;
            DESCRIPCION: string;
            FUNC_CONVER_TIPO_DATO: string;
        };
    };
    constructor() { }
}
